import { SubscriptionFeatureType } from '../../types';
import { OrgComponentProps } from '../../typescriptHelpers';
import * as React from 'react';
import { SettingsSwitchRow } from '../SettingsSwitchRow';
import { PlanRestrictedFeatureWrapper } from '../planRestrictions/PlanRestrictedFeatureWrapper';
import { useSelector } from 'react-redux';
import { selectOrgSettings } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import Link from 'antd/lib/typography/Link';
import Text from 'antd/lib/typography/Text';

const EnableACLSetting: React.FC<OrgComponentProps> = (props) => {
    const isACLEnabled = useSelector((state: RootState) => selectOrgSettings(state, props.orgId).isACLEnabled);

    return (
        <PlanRestrictedFeatureWrapper feature={SubscriptionFeatureType.RoleBasedACL}>
            {(isDisabled) => (
                <SettingsSwitchRow
                    featureType={SubscriptionFeatureType.RoleBasedACL}
                    title="Enable role-based access controls"
                    description={
                        <Text>
                            Which features users can interact with in Runway will be determined by their assigned user
                            groups. Read more about role-based access controls in our{' '}
                            <Link
                                href="https://docs.runway.team/using-runway/organization-settings/team#groups"
                                target="_blank"
                            >
                                documentation
                            </Link>
                            .
                        </Text>
                    }
                    isLoading={false}
                    checked={isACLEnabled}
                    disabled={true}
                    switchTooltipText={isDisabled ? null : 'Contact us to update this setting'}
                />
            )}
        </PlanRestrictedFeatureWrapper>
    );
};

export default EnableACLSetting;
